import React from 'react';
import type { BadgeCategory, Badge } from '@/types/achievement';

interface BadgeCollectionProps {
  badgeCategories: BadgeCategory[];
  selectedCategory: string;
  onBadgeClick?: (badge: Badge) => void;
}

const BadgeCollection: React.FC<BadgeCollectionProps> = ({ 
  badgeCategories, 
  selectedCategory,
  onBadgeClick 
}) => {
  const handleBadgeClick = (badge: Badge) => {
    if (onBadgeClick) {
      onBadgeClick(badge);
    }
  }; 
  
  // Get skillstree name from API response
  const getSkillstreeName = (badge: Badge) => {
    return badge?.skillstree?.skillstree_name || 'Unknown Skillstree';
  };

  // Get microskill name from API response
  const getMicroskillName = (badge: Badge) => {
    return (badge?.microskill as any)?.version || badge.microskill as string || (badge?.microskill as any)?.code || 'Unknown Microskill';
  };

  // Get category name from API response
  const getCategoryName = (badge: Badge) => {
    return badge?.core_category?.name || badge?.category || 'Unknown Category';
  };

  return (
    <div className="flex flex-row flex-wrap gap-4 items-center justify-center md:justify-start pb-4">
      {badgeCategories.map((category, categoryIndex) => (
        <React.Fragment key={categoryIndex}>
          {category.badges.map((badge, badgeIndex) => {            
            const badgeName = badge.name || getMicroskillName(badge);
            const badgeTree = getSkillstreeName(badge);
            const badgeCategory = category.category || getCategoryName(badge);
            return (
            <div 
              key={badgeIndex} 
              className="flex flex-col items-center content-between text-center py-3 w-44 bg-white/40 border border-white rounded-lg shadow-sm cursor-pointer hover:bg-white/60 transition-colors"
              onClick={() => handleBadgeClick({ ...badge, category: badgeCategory })}
            >
              <img className="h-16 w-auto object-center" src={badge.image || badge.image_url || '/pages/achievements/Digital-Badges.png'} alt={badgeName} onError={(e) => e.currentTarget.src = '/pages/achievements/Digital-Badges.png'}/>
              <span className="text-sm text-white py-1">{badgeName}</span>
              <span className="text-sm font-medium bg-blue-100 text-blue-900 rounded-sm mt-1 py-0.5 px-2.5">
                {badgeCategory}
              </span>
              <span className="text-sm text-white/70 py-1">{badgeTree}</span>
            </div>
          )})}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BadgeCollection;